import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserView, MobileView } from 'react-device-detect'

ReactDOM.render(
  <>
    <BrowserView>
      <App />
    </BrowserView>
    <MobileView>
      <div style={{
        minHeight: '100vh',
        background: '#f6f5f7',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        textAlign: 'center',
        fontFamily: "'Inter', -apple-system, sans-serif",
      }}>
        <a href="https://makeresume.co" style={{ textDecoration: 'none', marginBottom: '40px' }}>
          <img src="/logo.png" alt="makeresume.co" style={{ height: '36px', width: 'auto' }} />
        </a>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '36px 28px',
          boxShadow: '0 4px 32px rgba(79, 127, 255, 0.10)',
          maxWidth: '320px',
          width: '100%',
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #4f7fff 0%, #7b52ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: '24px',
          }}>
            💻
          </div>
          <h2 style={{
            margin: '0 0 12px',
            fontSize: '20px',
            fontWeight: '700',
            color: '#0d1128',
          }}>
            Desktop only for now
          </h2>
          <p style={{
            margin: '0 0 28px',
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: '1.6',
          }}>
            The resume editor works best on a larger screen. Open it on your computer to get started.
          </p>
          <a
            href="https://makeresume.co"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #4f7fff 0%, #7b52ff 100%)',
              color: 'white',
              textDecoration: 'none',
              padding: '12px 28px',
              borderRadius: '50px',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Back to makeresume.co
          </a>
        </div>
      </div>
    </MobileView>
  </>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
